import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
	import { sharePage } from '@/api/mall';
	import wx from "weixin-js-sdk";
	import {useRouter } from "vue-router";
	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	const router = useRouter();
	onMounted(() => {
		let path = location.href;
		let source = 0;
		if(path.indexOf('/indexView') != -1 || path.indexOf('type=1') != -1){
			source = 1;
		} else if(path.indexOf('/chat') != -1 || path.indexOf('type=2') != -1){
			source = 2;
		}
		localStorage.setItem("source",source.toString());
		//微信分享使用的，所以判断微信浏览器执行该方法
		// 通过 ? 分割获取后面的参数字符串
		let urlStr:any = location.href?.split('?')[1];
		// 创建空对象存储参数
		let obj : any = {};
		let page:any = '';
		// 再通过 & 将每一个参数单独分割出来
		let paramsArr : any = urlStr?.split('&');
		if(paramsArr && paramsArr.length > 0){
			for (let i = 0, len = paramsArr.length; i < len; i++) {
				// 再通过 = 将每一个参数分割为 key:value 的形式
				let arr = paramsArr[i]?.split('=')
				obj[arr[0]] = arr[1].slice(0,1);
			}
			if (obj.type) {
				page = obj.type;
			}
		}
		let ua = navigator.userAgent.toLowerCase();
		var isWeixin = ua.indexOf('micromessenger') !== -1;
		if (isWeixin && !/miniprogram/.test(ua)) {
			let type = Boolean(location.href.includes('chat')) ? 2 : 1;
			sharePage({
				url: location.href.split("#")[0] + '?type=' + type
			}).then((res : any) => {
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: res.data.appId, // 必填，公众号的唯一标识
					timestamp: res.data.timestamp, // 必填，生成签名的时间戳
					nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
					signature: res.data.signature, // 必填，签名
					jsApiList: [
						'onMenuShareTimeline', // 分享到朋友圈接口
						'onMenuShareAppMessage', //  分享到朋友接口
						'updateTimelineShareData', // 分享到朋友圈接口v1.4.0
						'updateAppMessageShareData', //  分享到朋友接口v1.4.0
					],
				});
				wx.ready(function () {
					let shareData : any = {
							title: '【紫猫跨境AI】免费用，为每位卖家提供不发工资的运营专家', // 分享标题
							desc: '紫猫全面接入ChatGPT，拥有大量跨境运营模版，智能生成Listing写作等，以及AI作图等。', // 分享描述
							link: location.host + '?type=1', // 分享链接
							imgUrl: 'https://ai.zimaocloud.com/static/zimao.png',// 分享图标
						}
					wx.ready(function () {
						wx.updateAppMessageShareData(shareData)
						wx.updateTimelineShareData(shareData)
						wx.onMenuShareAppMessage(shareData)
						wx.onMenuShareTimeline(shareData)
					})
				})
				if(page == 2){
					router.push({
						path:'/chat',
					});
				}

			})
		}
	})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})